import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const AIToolSelector = ({ value, onChange, aiTools, disabled }) => {
  const options = aiTools?.map(tool => ({
    value: tool?.id,
    label: tool?.name,
    description: tool?.description
  })) || [];

  return (
    <div className="space-y-2">
      <Select
        label="Select AI Tool"
        description="Choose the AI platform you want to generate prompts for"
        options={options}
        value={value}
        onChange={onChange}
        disabled={disabled}
        searchable
        required
        placeholder={disabled ? "Select a use case first" : "Select an AI tool..."}
      />
      {value && aiTools?.find(t => t?.id === value) && (
        <div className="flex items-start gap-2 p-3 bg-muted rounded-lg">
          <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
          <p className="text-xs text-muted-foreground">
            {aiTools?.find(t => t?.id === value)?.description}
          </p>
        </div>
      )}
    </div>
  );
};

export default AIToolSelector;